import { CompanyBranchEditPage } from "@/features/company/pages/CompanyBranchEdit";

const CompanyBranchEdit = () => {
  return <CompanyBranchEditPage />;
};

export default CompanyBranchEdit;
